
import { Options } from "vue-property-decorator";
import DefaultLayout from "@/layout/DefaultLayout.vue";
import { mixins } from "vue-class-component";
import { namespace } from "vuex-class";
import UserForm from "@/views/users/UserForm.vue";
import { FormCreateMixin } from "@/mixins/form/FormCreateMixin";

const UserModule = namespace("users");
@Options({
  components: { UserForm, DefaultLayout },
})
export default class UserAdd extends mixins(FormCreateMixin) {
  protected resource = "api/users";
  protected updateRouteName = "UserEdit";

  @UserModule.Action("create")
  protected createAction: any;

  @UserModule.Action("resetSave")
  protected resetAction: any;

  @UserModule.Getter("getDataItem")
  protected item: any;

  @UserModule.Getter("getSuccess")
  protected success: any;

  @UserModule.Getter("getIsLoading")
  protected isLoading: any;
}
